(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pdp_buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
        if (!document.querySelector('.tooltip')) {
            return;
        }

        const tooltip = document.querySelector('.tooltip');
        const readMoreLink = document.querySelector('.read-more-link');
        const tooltipClose = document.querySelector('.tooltip-close');

        readMoreLink.addEventListener('click', function() {
            tooltip.classList.add('active');
        });

        tooltipClose.addEventListener('click', function() {
            tooltip.classList.remove('active');
        });

        document.addEventListener('click', function(event) {
            if (!tooltip.contains(event.target) && !readMoreLink.contains(event.target) || event.target == tooltipClose) {
                tooltip.classList.remove('active');
            }
        });
    });
  } catch(e) { console.error(e); }
})();

})();
